import { RefObject, useEffect } from 'react';

/** Fecha um painel flutuante com clique fora da área (`ancora`: botão + painel) ou com Esc. */
export function useFechaFora(ancora: RefObject<HTMLElement>, aberto: boolean, fechar: () => void): void {
  useEffect(() => {
    if (!aberto) return undefined;
    const clique = (e: MouseEvent) => {
      if (ancora.current && !ancora.current.contains(e.target as Node)) fechar();
    };
    const tecla = (e: KeyboardEvent) => {
      if (e.key === 'Escape') fechar();
    };
    document.addEventListener('mousedown', clique);
    document.addEventListener('keydown', tecla);
    return () => {
      document.removeEventListener('mousedown', clique);
      document.removeEventListener('keydown', tecla);
    };
  }, [ancora, aberto, fechar]);
}
